import { LegislationItem, LineItemFlatRow } from "./MIS.interface";
import { getValue } from "@utils/lodash";

export const defaultDate = (): Date => {
  const d = new Date();
  d.setMonth(d.getMonth() - 2);
  d.setDate(1);
  return d;
};

export const getMonthNameWithYear = (base: Date, offset: number): string => {
  const d = new Date(base);
  d.setMonth(d.getMonth() - offset);
  const month = d.toLocaleString("default", { month: "short" });
  const year = d.getFullYear().toString().slice(-2);
  return `${month}-${year}`;
};

export const cleanPayload = (
  payload: Record<string, any>,
): Record<string, any> => {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(payload)) {
    if (v !== undefined && v !== null && v !== "") out[k] = v;
  }
  return out;
};

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const PAGE_FILTERS = [
  { label: "SiteMgmt-MIS", value: "SITE_MIS", id: "SITE_MIS" },
  { label: "MIS - Site Wise", value: "LOCATION", id: "LOCATION" },
  { label: "MIS - Region Wise", value: "REGION", id: "REGION" },
  { label: "MIS - Account Wise", value: "GROUP", id: "GROUP" },
  { label: "MIS - Vendor Wise", value: "VENDOR", id: "VENDOR" },
  {
    label: "MIS - Item Wise",
    value: "LINE_ITEM_WISE_REPORT",
    id: "LINE_ITEM_WISE_REPORT",
  },
  {
    label: "Line Item Report",
    value: "LINE_ITEM_REPORT",
    id: "LINE_ITEM_REPORT",
  },
  {
    label: "Compliance Scorecard",
    value: "COMPLIANCE_SCORECARD",
    id: "COMPLIANCE_SCORECARD",
  },
  { label: "Vendor - Historical", value: "YEAR_HISTORY", id: "YEAR_HISTORY" },
  //   {
  //     label: "Vendor - Scorecard/Attendance",
  //     value: "VENDOR_SCORECARD_ATTENDANCE",
  //     id: "VENDOR_SCORECARD_ATTENDANCE",
  //   },
  {
    label: "Rectification Report",
    value: "RECTIFICATION_REPORT",
    id: "RECTIFICATION_REPORT",
  },
];

export const flattenLineItemData = (
  legislation: LegislationItem[],
): LineItemFlatRow[] => {
  const rows: LineItemFlatRow[] = [];
  legislation.forEach((leg, legIdx) => {
    const legId = getValue(leg, "checkpoint[0].legislation_id", "");
    // Group header
    rows.push({
      _type: "group",
      _sno: legIdx + 1,
      _legislation_id: legId,
      _legislation_name: leg.legislation_name,
      _overall_score: leg.score,
    });
    // Sub-header (column labels)
    rows.push({ _type: "subheader" });
    // Item rows — one per checkpoint
    (leg.checkpoint ?? []).forEach((cp, cpIdx) => {
      rows.push({
        _type: "item",
        _row_index: cpIdx + 1,
        _legislation_id: cp.legislation_id || legId,
        _checkpoint: cp,
      });
    });
  });
  return rows;
};

export const COMPLIANCE_OPTIONS = [
  { label: "All", value: "" },
  { label: "NC", value: "NON_COMPLIED" },
  { label: "C", value: "COMPLIED" },
  { label: "NA", value: "NOT_APPLICABLE" },
  { label: "NP", value: "NOT_SUBMITTED" },
  {
    label: "NC+NP",
    value: "NON_COMPLIED,NOT_SUBMITTED",
  },
];
